<template>
    <div className="animated">
        <b-card>
            <b-card-header>
                <i class="icon-menu mr-1"></i>Lista konfiguracji
                <div class="card-header-actions">
                </div>
            </b-card-header>
            <b-card-body>
                <v-server-table id="configurationTable" ref="configurationTable" :url="apiUrl" :columns="columns" :options="options">
                    <div slot="label" slot-scope="props">
                        <b-badge v-for="(label, index) in props.row.label" :key="index" :style="{ 'background-color': label.color }" variant="primary">{{ label.name }}</b-badge>
                    </div>
                    <div slot="dateRange" slot-scope="props">
                        {{ props.row.dateRange.start.substring(0, 10) }} - {{ props.row.dateRange.end.substring(0, 10) }}
                    </div>
                    <div slot="actions" slot-scope="props">
                        <b-button @click="removeConfiguration(props.row._id)" style="margin-left: 2px" size="sm" variant="danger">
                            <i class="fa fa-remove"></i>
                        </b-button>
                    </div>
                </v-server-table>
            </b-card-body>
        </b-card>

        <Loading :loading="loading.processing" :text="loading.text"></Loading>
    </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
Vue.use(ServerTable);

import VueNotifications from "vue-notifications";
import Loading from "@/components/loading.vue";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

Vue.use(VueNotifications, options);

export default {
  name: "DataTable",
  components: {
    ServerTable,
    Event,
    Loading
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL + "/presets";
    }
  },
  methods: {
    removeConfiguration(id) {
      this.loading.processing = true;
      this.loading.text = "Usuwanie konfiguracji...";

      this.axios
        .delete(`${process.env.VUE_APP_API_URL}/presets`, {
          params: { id: id }
        })
        .then(res => {
          this.$store.commit('presets/REMOVE_PRESET', id);
          this.$refs.configurationTable.refresh();
          this.loading.processing = false;
          this.loading.text = "";
          this.showSuccessRemoveMsg();
        })
        .catch(err => {
          this.loading.processing = false;
          this.loading.text = "";
          this.showError();
        });
    }
  },
  notifications: {
    showSuccessRemoveMsg: {
      type: VueNotifications.types.success,
      title: "Sukces",
      message: "Pomyślnie usunięto konfigurację."
    },
    showError: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Nie udało się usunąć konfiguracji."
    }
  },
  data: function() {
    return {
      loading: {
        processing: false,
        text: ""
      },
      columns: [
        "_id",
        "name",
        "label",
        "chargeIncome",
        "containLabel",
        "containInvoice",
        "actions"
      ],
      options: {
        requestFunction: function(data) {
          return this.axios
            .get(this.url, {
              params: data
            })
            .catch(
              function(e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        },
        responseAdapter: function(resp) {
          var data = resp.data;
          return { data: data.data, count: data.count };
        },
        headings: {
          _id: "Id",
          name: "Nazwa",
          label: "Etykiety",
          chargeIncome: "Obciązenie/Przychód",
          containLabel: "Zawiera etykietę",
          containInvoice: "Zawiera fakturę",
          actions: "Akcje"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        }
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default"
    };
  }
};
</script>

<style lang="scss">
#configurationTable {
  width: 95%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
